import { isDevOrMocks } from "../../utils/mode";

import { getAssetsUrl } from "@helsenorge/framework-utils/hn-page";
import WebCompConsumer from "@helsenorge/framework-utils/web-component/consumer";

import { useAppSelector } from "../../store/reducer";
import { kanOppgavenBesvaresSelector } from "../../store/selectors/selectors-oppgaveDetaljer";

import styles from "../../styles/oppgave-detaljer.module.scss";

const SkjemaMicroweb = (): React.JSX.Element | null => {
  const oppgave = useAppSelector((state) => state.oppgaveDetaljer.oppgave);
  const kanBesvares = useAppSelector(kanOppgavenBesvaresSelector);
  const erSkjemaIOppgaveType = oppgave?.IntegrertVisning;
  const showSkjema =
    kanBesvares &&
    oppgave?.KanInnloggetInnbyggerUtforeOppgave &&
    erSkjemaIOppgaveType;

  return (
    <>
      {(isDevOrMocks || showSkjema) && (
        <div className={styles.detaljer_seksjon}>
          <WebCompConsumer
            domain={`${getAssetsUrl()}/skjema`}
            entryName="src/microweb-oppgave/index.tsx"
            componentName="hn-webcomp-skjema"
            includeHelsenorgeCss
            componentProps={{
              taskid: oppgave?.Id,
            }}
          />
        </div>
      )}
    </>
  );
};

export default SkjemaMicroweb;
